// AUTO-GENERATED by scripts/gen-icons.mjs — do not edit by hand.
import Svg from '../svg/upload.svg?react';
import { Icon } from '../Icon';
import { IconProps } from '../types';

export const UploadIcon = (props: IconProps) => <Icon svg={Svg} {...props} />;
